import { CartModalManager } from './cart-modal.manager'

export abstract class CommonProductButtonView {
  constructor(
    protected widget: HTMLElement,
    protected modalManager: CartModalManager
  ) {}

  abstract onClick(): void
}
